import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRouteConstants } from '../../../core/constants/api-routes';
import { SUPPRESS_GLOBAL_SPINNER } from '../../constants/http-context-tokens';
import { Observable } from 'rxjs';
import { CoordinateIsInUSOrTerritoriesRequest } from './models/coordinate-is-in-us-or-territories-request';
import { ValidationResult } from './models/validation-result';

@Injectable({
    providedIn: 'root',
})
export class ValidationService {
    private readonly applicationApiRoute = ApiRouteConstants.Validation;
    private readonly http = inject(HttpClient);

    constructor() {}

    coordinateIsInUSOrTerritories(
        request: CoordinateIsInUSOrTerritoriesRequest,
    ): Observable<ValidationResult> {
        return this.http.post<ValidationResult>(
            this.applicationApiRoute.coordinateIsInUSOrTerritories,
            request,
            {
                context: new HttpContext().set(SUPPRESS_GLOBAL_SPINNER, true),
            },
        );
    }
}
